"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTokenManager = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const errors_1 = require("./errors");
class BaseTokenManager {
    constructor() {
        this.tokenCacheMap = new Map();
        this.forceUpdateAccessToken = false;
    }
    /**
     * 消费 forceUpdateAccessToken 标记
     * 业务接口返回token无效的错误后，调用updateAccessToken方法将forceUpdateAccessToken设置为true
     * 下一次请求accessToken时调用consumeForceUpdateAccessToken强制刷新token并将forceUpdateAccessToken设置为false
     */
    consumeForceUpdateAccessToken() {
        if (this.forceUpdateAccessToken) {
            this.forceUpdateAccessToken = false;
            return true;
        }
        return false;
    }
    requestTradingBotToken() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getUserId()
            .pipe((0, operators_1.mergeMap)((userId) => {
            const identifier = userId;
            if (!identifier) {
                throw errors_1.ErrorNotGetUserId;
            }
            if (this._checkTradingTokenValid(identifier)) {
                return (0, trade_utils_lib_1.getTradeDependencyInstance)()
                    .getAccessToken(this.consumeForceUpdateAccessToken())
                    .pipe((0, operators_1.map)((token) => {
                    var _a;
                    let cacheToken = this.getTokenCache(identifier);
                    const res = {
                        id: identifier,
                        apiSecret: cacheToken.apiSecret,
                        tradingToken: cacheToken.tradingToken,
                        swapApiSecret: cacheToken.swapApiSecret,
                        awsToken: token.toString(),
                        swapToken: cacheToken === null || cacheToken === void 0 ? void 0 : cacheToken.swapToken,
                        traderToken: cacheToken === null || cacheToken === void 0 ? void 0 : cacheToken.traderToken,
                        traderApiSecret: cacheToken === null || cacheToken === void 0 ? void 0 : cacheToken.traderApiSecret,
                        tokenExpire: (_a = cacheToken === null || cacheToken === void 0 ? void 0 : cacheToken.tokenExpire) !== null && _a !== void 0 ? _a : 0,
                    };
                    return res;
                }))
                    .pipe((0, operators_1.tap)((tradingTokenInfo) => {
                    this.updateTokenCacheResult(identifier, tradingTokenInfo);
                }));
            }
            return this.requestTradingBotTokenImpl(userId);
        }));
    }
    /**
     * 校验trading token是否过期
     *
     * @private
     * @param identity
     * @param swapRequire
     */
    _checkTradingTokenValid(identity) {
        let tradingTokenInfo = this.getTokenCache(identity);
        if (!tradingTokenInfo || !tradingTokenInfo.tradingToken) {
            return false;
        }
        let expTime = tradingTokenInfo.tokenExpire;
        let now = new Date().getTime();
        return !(expTime <= now || Math.abs((expTime - new Date().getTime()) / 1000) < 3 * 60);
    }
    /**
     * 更新token缓存
     * @param identify
     * @param tradingToken
     */
    updateTokenCacheResult(identify, tradingToken) {
        this.tokenCacheMap.set(identify, tradingToken);
    }
    /**
     * 从缓存中获取token
     * @param identify
     */
    getTokenCache(identify) {
        return this.tokenCacheMap.get(identify);
    }
    /**
     * 强制刷新token, 忽略是否有效
     */
    updateToken() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getUserId()
            .pipe((0, operators_1.mergeMap)((userId) => {
            if (!userId) {
                return (0, rxjs_1.throwError)({ code: -1, message: "not has user id" });
            }
            return this.requestTradingBotTokenImpl(userId);
        }));
    }
    /**
     * 强制刷新accessToken,
     */
    updateAccessToken() {
        this.forceUpdateAccessToken = true;
    }
}
exports.BaseTokenManager = BaseTokenManager;
